<template>

    <div class="w-full">
        <div class="lg:flex mb-5">
            <div class="w-full lg:w-1/3 h-auto relative">
                <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest w-full" id="inline-full-name" type="text" placeholder="Type to search for a video" v-model="searchQuery">
                <div class="absolute top-0 right-0 pr-3 pt-2">
                    <i class="fa fa-circle-notch fa-spin" v-if="searching"></i>
                </div>
            </div>
            <div class="flex w-full lg:w-2/3 text-right items-center">
                <Dropdown class="ml-auto mt-5 lg:mt-0">
                    <template #trigger="{ hasFocus, isOpen }">
                        <div class="px-2 py-1 text-white rounded" :class="[(hasFocus || isOpen) ? 'bg-blue-500' : 'bg-blue-700']">
                            <i class="fas fa-filter"></i>
                        </div>
                    </template>
                    <template #dropdown>
                        <div class="mt-3 bg-white xl:border rounded-lg w-48 py-2 shadow-xl text-left">
                            <a href="#" class="block hover:text-white px-4 py-2 hover:bg-blue-500" :class="{'bg-blue-500 text-white': orderByStatus == 'desc', 'text-gray-800': orderByStatus !== 'desc'}" @click="orderBy('desc')">Newest first</a>
                            <a href="#" class="block hover:text-white mt-0 px-4 py-2 hover:bg-blue-500" :class="{'bg-blue-500 text-white': orderByStatus == 'asc', 'text-gray-800': orderByStatus !== 'asc'}" @click="orderBy('asc')">Oldest first</a>
                        </div>
                    </template>
                </Dropdown>
            </div>
        </div>

        <CustomTable class="bg-white rounded shadow-md group">
            <template v-slot:header>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Thumbnail</th>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Video Details</th>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Action</th>
            </template>
            <template v-slot:body>
                <tr class="hover:bg-grey-lighter" v-for="video in videos">
                    <td class="py-4 px-6 border-b border-grey-light w-48 text-center">
                        <progressive-img class="video-thumbnail" fallback="/static/image-unavailable.png" :src="video.thumbnailUrl" />
                        <StarRating :id="video.id" :rating="video.rating" />
                    </td>
                    <td class="py-4 px-6 border-b border-grey-light">
                        <div class="video-details">
                            <strong>{{ video.title }}</strong> <br/>
                            <strong>Price: ${{ video.price }}</strong> <br/>
                            {{ video.created_at | displayLocalDateTime }} <br/>
                            Duration: {{ video.length | timecode }} <br/>
                            Uploader: {{ video.user.name }} <br />
                            <strong style="color: red;" v-if="video.embargo !== null">Embargo: {{ video.embargo }}</strong>
                        </div>
                        <!-- <div class="infocons mt-2">
                            <span v-if="video.status == 'pending'">
                                <i data-toggle="tooltip" data-placement="top" title="Pending Approval" class="fa fa-circle-o pending-approve"></i>
                            </span>
                            <span v-if="video.status == 'approved'">
                                <i data-toggle="tooltip" data-placement="top" title="Approved" class="fa fa-check-circle-o approved"></i>
                            </span>
                            <span v-if="video.status == 'declined'">
                                <i data-toggle="tooltip" data-placement="top" title="Approval Declined" class="fa fa-circle declined"></i>
                            </span>

                            <span v-if="video.visibility == 'public'">
                                <i data-toggle="tooltip" data-placement="top" title="Public" class="fa fa-globe public ml-2"></i>
                            </span>
                            <span v-if="video.visibility == 'private'">
                                <i data-toggle="tooltip" data-placement="top" title="Unlisted" class="fa fa-globe unlisted ml-2"></i>
                            </span>
                            <span v-if="video.visibility == 'unlisted'">
                                <i data-toggle="tooltip" data-placement="top" title="Unlisted" class="fa fa-globe unlisted ml-2"></i>
                            </span>
                        </div> -->
                        <div class="denied-information" style="margin-top: 20px;" v-if="video.status == 'declined' && video.declined_message !== null">
                            <strong style="color: red;">This video was denied.</strong> <br/>
                            <strong>Reason: </strong> {{ video.declined_message.message }} <br/>
                            Declined by {{ video.declined_message.reviewer.name }} at  {{ video.declined_message.created_at | displayLocalDateTime}}.<br/>
                        </div>
                    </td>
                    <td class="py-4 px-6 border-b border-grey-light">
                        <button class="bg-blue-600 px-3 py-2 text-white text-xs rounded mr-3" v-if="video.content_release !== null" v-on:click="contentRelease(video.content_release.id)">
                            <span class="fa fa-signature"></span>
                        </button>
                        <button class="bg-blue-600 px-3 py-2 text-white text-xs rounded mr-3" v-on:click="editVideo(video)">
                            <span class="fa fa-cog"></span>
                        </button>
                        <button class="bg-green-600 px-3 py-2 text-white text-xs rounded" v-on:click="downloadVideo(video.id)">
                            <i class="fa fa-download"></i>
                        </button>
                    </td>
                </tr>
                <tr class="bg-grey-lighter text-center" v-if="videos.length == 0">
                    <td class="py-5" colspan="4">
                        No videos were found for this query. Try broadening your search query.
                    </td>
                </tr>

                <!-- <tr class="bg-grey-lighter text-center" v-if="polling">
                    <td class="py-5" colspan="4">
                        <h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
                    </td>
                </tr> -->
                <infinite-loading @infinite="infiniteHandler" style="opacity: 0; height: 0;">
                    <span slot="no-more"></span>
                </infinite-loading>
            </template>
            
        </CustomTable>
        <edit-video-details-modal></edit-video-details-modal>
    </div>
</template>

<script>

    import { EventBus } from '@/utils/events';
    import * as Config from '@/config'
    import { mapState, mapGetters } from 'vuex';
    import moment from 'moment';
    import EditVideoDetailsModal from './modals/EditVideoDetails'
    import InfiniteLoading from 'vue-infinite-loading';
    import CustomTable from '@/components/general/CustomTable'
    import Dropdown from '@/components/partials/Dropdown'
    import StarRating from '@/components/general/StarRating'

	export default {
        name: 'AdminVideoManager',
        components: {
            'edit-video-details-modal': EditVideoDetailsModal,
            InfiniteLoading,
            CustomTable,
            Dropdown,
            StarRating
		},
		data () {
			return {
                options: this.getAuthorizationHeader(),

                videos: [],
                
                resource_url: Config.apiPath + "/api/v2/admin/videos",
                searchQuery: '',
                current_page: 1,
                last_page: null,
                searching: false,
                searchDebounce: null,
                orderByStatus: null,
			}
        },
        methods: {

            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            
            updateResource(data){
                this.videos = data;
            },

            downloadVideo(id) {
                this.$http.get(Config.apiPath + "/api/v2/admin/videos/" + id + "/download", this.getAuthorizationHeader())
                    .then(response => {
                        var link = document.createElement('a');
                        document.body.appendChild(link);
                        link.href = response.data;
                        link.click();
                        document.body.removeChild(link);
                    });
            },

            contentRelease(id) {
                this.$http.get(Config.apiPath + "/api/v2/admin/videos/" + id + "/content-release", this.getAuthorizationHeader())
                    .then(response => {
                        var win = window.open(response.data, '_blank');
                        win.focus();
                    });
            },
            
            editVideo(video) {
                console.log('clicked')
                EventBus.$emit('admin-edit-video-open-modal', video);
            },

            infiniteHandler($state) {

                var _this = this;

                if(this.last_page !== null) {
                    if((this.current_page - 1) == this.last_page) return
                }

                this.$http.get(this.computeResourceUrl(), this.getAuthorizationHeader()).then((response) => {

                    _this.current_page = response.data.current_page + 1;
                    _this.last_page = response.data.last_page

                    var data = response.data.data;

                    const temp = [];
                    for (var i = 0; i < data.length; i++) {
                        temp.push(data[i]);
                    }
                    _this.videos = _this.videos.concat(temp);

                    $state.loaded();

                });

            },

            search() {
                this.current_page = 1
                this.videos = []

                var _this = this

                this.$http.get(this.computeResourceUrl(), this.getAuthorizationHeader()).then((response) => {
                    _this.current_page = response.data.current_page + 1;
                    var data = response.data.data;
                    _this.videos = data
                    _this.searching = false
                });
            },

            orderBy(value) {
                this.orderByStatus = value
                this.search()
            },

            computeResourceUrl() {
                var baseURL = this.resource_url + "?page=" + (this.current_page)

                if(this.searchQuery !== '') {
                    baseURL += "&search=" + this.searchQuery
                }

                if(this.orderByStatus !== null) {
                    baseURL += "&orderBy=" + this.orderByStatus
                }

                return baseURL

            }

        },
        watch: {
            searchQuery: function() {
                this.searching = true
                clearTimeout(this.searchDebounce)
                this.searchDebounce = setTimeout(() => {
                    this.search()
                }, 600)
            }
        },
        filters: {
            timecode: function(value) {
                if(value !== null) {
                    var seconds = Math.floor( value % 60 ).toString();
                    var minutes = Math.floor( value / 60 ).toString();
                    if( seconds.length === 1 ){
                        seconds = '0' + seconds;
                    }                
                    return minutes + ':' + seconds;
                }
            },
            displayLocalDateTime: function(date) {
                return moment.utc(date).local().format('MMMM Do YYYY, h:mm a');
            }
        }
	}
</script>

<style scoped>

    .filter {
        background-color: #fff;
        border-radius: 6px;
        min-height: 20px;
        width: 100%;
        height: auto;
    }

    .max-w-200 {
        max-width: 200px;
        height: auto;
    }


</style>
